import React from 'react';
import { DashboardProps } from '../ModernLayoutContainer';
import { Avatar, Col, Icon, Row } from 'antd';
import _ from 'lodash';
import { XCDPIcon } from 'o2o_layout';
import { getPrimaryColor } from '../../../../common/helper';

interface IProps extends DashboardProps {
  collapsed: any;
  onCollapse: any;
}

export const MenuHeaderLogo = (props: IProps) => {
  const renderLogoCompany = () => {
    return props.user && _.get(props.user, 'orgCtx.organization.imageLink', undefined) ? (
      <Avatar
        shape={'square'}
        size={40}
        style={{ borderRadius: 5 }}
        src={_.get(props.user, 'orgCtx.organization.imageLink', undefined)}
      />
    ) : (
      <Icon
        component={() => {
          return <XCDPIcon fillBackground={getPrimaryColor(props.uiSetting)} />;
        }}
        style={{ fontSize: 40 }}
      />
    );
  };

  const renderCompanyName = () => {
    return (
      <div
        style={{
          fontSize: 16,
          fontWeight: 500,
        }}
        className='inter-500'
      >
        <div
          style={{
            color: 'var(--primary-color)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: 150,
          }}
        >
          <span style={{ fontWeight: 500 }}>
            {props.user ? (props.user.orgCtx ? props.user.orgCtx.organization.name : 'PangoCDP') : 'PangoCDP'}
          </span>
        </div>
        <div style={{ fontSize: 14 }}>Account</div>
      </div>
    );
  };
  return (
    <>
      <Row
        type='flex'
        gutter={[10, 10]}
        align='middle'
        justify='space-between'
        style={{ padding: '25px 15px 0px 15px' }}
      >
        {!props.collapsed ? (
          <Col>
            <Row type='flex' align='middle' gutter={[20, 10]}>
              <Col>{renderLogoCompany()}</Col>
              <Col>{renderCompanyName()}</Col>
            </Row>
          </Col>
        ) : null}
        <Col>
          {props.collapsed ? (
            <div onClick={props.onCollapse} style={{ cursor: 'pointer', paddingLeft: 7 }}>
              <Avatar
                shape='square'
                style={{
                  background: 'var(--primary-color)',
                }}
                icon={
                  <Icon
                    component={() => {
                      return (
                        <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path
                            fill-rule='evenodd'
                            clip-rule='evenodd'
                            d='M2.39986 14.8491C2.06 14.8491 1.78448 14.5735 1.78448 14.2337L1.78448 1.92599C1.78448 1.58613 2.05999 1.3106 2.39986 1.3106L14.7076 1.3106C15.0474 1.3106 15.3229 1.58613 15.3229 1.92599L15.3229 14.2337C15.3229 14.5736 15.0474 14.8491 14.7076 14.8491L2.39986 14.8491ZM0.553711 14.2337C0.553711 15.2533 1.38026 16.0798 2.39986 16.0798L14.7076 16.0798C15.7272 16.0798 16.5537 15.2533 16.5537 14.2337L16.5537 1.92599C16.5537 0.906335 15.7272 0.0798327 14.7076 0.0798327L2.39986 0.0798338C1.38027 0.0798339 0.55371 0.906337 0.55371 1.92599L0.553711 14.2337Z'
                            fill='white'
                          />
                          <path
                            fill-rule='evenodd'
                            clip-rule='evenodd'
                            d='M11.8358 16.0798C12.1756 16.0798 12.4511 15.8043 12.4511 15.4644L12.4511 0.695217C12.4511 0.355361 12.1756 0.079833 11.8358 0.079833C11.4959 0.079833 11.2204 0.355361 11.2204 0.695217L11.2204 15.4644C11.2204 15.8043 11.4959 16.0798 11.8358 16.0798Z'
                            fill='white'
                          />
                          <path
                            fill-rule='evenodd'
                            clip-rule='evenodd'
                            d='M5.65703 10.156C5.89735 10.3963 6.28699 10.3963 6.52731 10.156L8.16832 8.51495C8.40864 8.27462 8.40864 7.88504 8.16832 7.64472L6.52731 6.00369C6.28699 5.76336 5.89735 5.76336 5.65703 6.00369C5.41671 6.24402 5.41671 6.6336 5.65703 6.87393L6.86291 8.07983L5.65703 9.28574C5.41671 9.52607 5.41671 9.91568 5.65703 10.156Z'
                            fill='white'
                          />
                          <path
                            fill-rule='evenodd'
                            clip-rule='evenodd'
                            d='M8.75884 15.4644C8.75884 15.8043 9.03437 16.0798 9.37422 16.0798L14.2973 16.0798C14.6372 16.0798 14.9127 15.8043 14.9127 15.4644C14.9127 15.1246 14.6372 14.8491 14.2973 14.8491L9.37422 14.8491C9.03437 14.8491 8.75884 15.1246 8.75884 15.4644Z'
                            fill='white'
                          />
                          <path
                            fill-rule='evenodd'
                            clip-rule='evenodd'
                            d='M8.75884 0.695217C8.75884 1.03507 9.03437 1.3106 9.37422 1.3106L14.2973 1.3106C14.6372 1.3106 14.9127 1.03507 14.9127 0.695217C14.9127 0.355361 14.6372 0.0798328 14.2973 0.0798328L9.37422 0.0798332C9.03437 0.0798332 8.75884 0.355361 8.75884 0.695217Z'
                            fill='white'
                          />
                        </svg>
                      );
                    }}
                  />
                }
              />
            </div>
          ) : (
            <Icon
              style={{ cursor: 'pointer' }}
              onClick={props.onCollapse}
              component={() => {
                return (
                  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M16.8741 18.1012C17.2777 18.1012 17.6049 17.774 17.6049 17.3704L17.6049 2.75505C17.6049 2.35147 17.2777 2.02428 16.8741 2.02428L2.25872 2.02428C1.85514 2.02428 1.52795 2.35147 1.52795 2.75505L1.52794 17.3704C1.52794 17.774 1.85514 18.1012 2.25871 18.1012L16.8741 18.1012ZM19.0664 17.3704C19.0664 18.5812 18.0849 19.5627 16.8741 19.5627L2.25871 19.5627C1.04788 19.5627 0.0664063 18.5812 0.0664064 17.3704L0.0664077 2.75505C0.0664078 1.54421 1.04788 0.562743 2.25872 0.562743L16.8741 0.562744C18.0849 0.562744 19.0664 1.54422 19.0664 2.75505L19.0664 17.3704Z'
                      fill='black'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M5.66897 19.5627C5.26539 19.5627 4.9382 19.2356 4.9382 18.832L4.9382 1.29351C4.9382 0.889933 5.26539 0.562743 5.66897 0.562743C6.07255 0.562743 6.39974 0.889933 6.39974 1.29351L6.39974 18.832C6.39974 19.2356 6.07255 19.5627 5.66897 19.5627Z'
                      fill='black'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M13.0062 12.5282C12.7208 12.8136 12.2581 12.8136 11.9728 12.5282L10.0241 10.5794C9.73867 10.2941 9.73867 9.83143 10.0241 9.54604L11.9728 7.59732C12.2581 7.31193 12.7208 7.31193 13.0062 7.59732C13.2916 7.88271 13.2916 8.34534 13.0062 8.63073L11.5742 10.0627L13.0062 11.4948C13.2916 11.7801 13.2916 12.2428 13.0062 12.5282Z'
                      fill='black'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M9.32282 18.832C9.32282 19.2356 8.99563 19.5627 8.59205 19.5627L2.74589 19.5627C2.34231 19.5627 2.01512 19.2356 2.01512 18.832C2.01512 18.4284 2.34231 18.1012 2.74589 18.1012L8.59205 18.1012C8.99563 18.1012 9.32282 18.4284 9.32282 18.832Z'
                      fill='black'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M9.32282 1.29351C9.32282 1.69709 8.99563 2.02428 8.59205 2.02428L2.7459 2.02428C2.34232 2.02428 2.01512 1.69709 2.01512 1.29351C2.01512 0.889933 2.34232 0.562743 2.7459 0.562743L8.59205 0.562743C8.99563 0.562743 9.32282 0.889934 9.32282 1.29351Z'
                      fill='cur'
                    />
                  </svg>
                );
              }}
            />
          )}
        </Col>
      </Row>
    </>
  );
};
